import { useEffect, useRef, useState } from "react";

type Props = {
  text: string;
  maxLines?: number;
  lineHeightEm?: number; // Line height in em units
}

export const ExpandableText = ({ text, maxLines = 2, lineHeightEm = 1.5 }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [maxHeightPx, setMaxHeightPx] = useState(0);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const style = getComputedStyle(el);
      const fontSize = parseFloat(style.fontSize);
      const lineHeightPx = fontSize;
      const calculatedMaxHeightPx = maxLines * lineHeightPx;
      setMaxHeightPx(calculatedMaxHeightPx);
      setIsOverflowing(el.scrollHeight > calculatedMaxHeightPx);
    }
  }, [text, maxLines, lineHeightEm]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="max-w-md">
      <div
        ref={textRef}
        className="whitespace-pre-wrap overflow-hidden"
        style={{
          // lineHeight: `${lineHeightEm}em`,
          maxHeight: isExpanded ? "none" : `${maxHeightPx}px`,
        }}
      >
        {text}
      </div>
      {isOverflowing && (
        <button
          onClick={toggleExpand}
          className="mt-2 text-sm text-blue-600 hover:text-blue-800 focus:outline-none"
        >
          {isExpanded ? "Свернуть" : "Развернуть"}
        </button>
      )}
    </div>
  );
};
